import React from 'react';

import AssigneeFilters from './assignee';
import StatusFilter from './status';

export default function Filters() {
  return (
    <div className="d-flex justify-content-end gap-2">
      <AssigneeFilters/>
      <StatusFilter/>
    </div>
  );
}
